import * as APITypes from "../graphql";

type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const eventsByOrganizationGroupAndStartTimeCustom =
  /* GraphQL */ `query CustomEventsByOrganizationGroupAndStartTime(
  $organizationGroup: String!
  $startTime: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelEventFilterInput
  $limit: Int
  $nextToken: String
) {
  eventsByOrganizationGroupAndStartTime(
    organizationGroup: $organizationGroup
    startTime: $startTime
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      name
      description
      imageUrl
      startTime
      endTime
      circleEventId
      isHidden
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        creator
        __typename
      }
      attendee {
        items {
          id
          user {
            avatarUrl
          }
          organizationGroup
          eventAttendeeId
          eventAttendeeUserId
          status
          requestStatus
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          eventAttendeeInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interests
      privacy
      admins
      timezone
      location
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
    APITypes.EventsByOrganizationGroupAndStartTimeQueryVariables,
    APITypes.EventsByOrganizationGroupAndStartTimeQuery
  >;
